import { ReactElement } from 'react';
import defaultBackground from '../../assets/partners/bg_landing_default.png';
import zubaleBg from '../../assets/img/png/zubalero.png';
import mercadoLibreBg from '../../assets/partners/bg_landing_meli.png';
import mercadoLibreHeruLogo from '../../assets/img/png/heru-meli.png';
import didiLogo from '../../assets/partners/login_heru_x_didi.png';
import didiBg from '../../assets/partners/bg_landing_didi.png';
import heruLogo from '../../assets/img/svg/heru-logo-v3.svg';

export enum LandingUTMSource {
	MERCADO_LIBRE_AFILIADOS = 'mercado_libre_afiliados',
	ZUBALE = 'zubale',
	DIDI = 'didi',
	DEFAULT = 'default',
}

type AuthLanding = {
	utm_source: LandingUTMSource;
	title: ReactElement;
	parterLogo: string;
	partnerBackground: string;
	slider: ReactElement[];
};

export const AUTH_LANDING: Record<LandingUTMSource, AuthLanding> = {
	default: {
		utm_source: LandingUTMSource.DEFAULT,
		title: (
			<>
				Haz las paces con <br />
				<b className='text-h-primary'>tus impuestos.</b>
				<br />
				¡Comienza ahora!
			</>
		),
		parterLogo: heruLogo,
		partnerBackground: defaultBackground,
		slider: [
			<div className='flex flex-col gap-4 text-h-dark-menu'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Ahorra tiempo, dinero y preocupaciones
				</h2>
				<p className='text-[20px]'>
					Nos encargamos de tu impuestos mientras tú te enfocas en lo que
					realmente importa: tus ingresos.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-h-dark-menu'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Tecnología fiscal que habla tu idioma
				</h2>
				<p className='text-[20px]'>
					Transformamos términos complejos en soluciones claras y accesibles.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-h-dark-menu'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Declarar no tiene que ser un dolor de cabeza
				</h2>
				<p className='text-[20px]'>
					Con heru, conviertes una tarea tediosa en un proceso rápido y
					sencillo.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-h-dark-menu'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Tu contador personal, disponible 24/7
				</h2>
				<p className='text-[20px]'>
					Con heru, tienes un experto fiscal siempre a tu alcance.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-h-dark-menu'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Tu aliado fiscal en la era digital
				</h2>
				<p className='text-[20px]'>
					Combinamos nuestra experiencia tributaria con innovación tecnológica
					para servirte mejor.
				</p>
			</div>,
		],
	},
	zubale: {
		utm_source: LandingUTMSource.ZUBALE,
		title: (
			<h1>
				Haz las paces con <br />
				<b className='text-h-primary'>tus impuestos.</b>
				<br />
				¡Comienza ahora!
			</h1>
		),
		parterLogo: heruLogo,
		partnerBackground: zubaleBg,
		slider: [
			<div className='flex flex-col gap-4 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Estrategia fiscal a tu medida
				</h2>
				<p className='text-[20px]'>
					Te ayudaremos a decidir cuál es tu mejor opción en términos de
					estrategia fiscal para que recibas tus ingresos.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Finaliza tu alta como zubalero
				</h2>
				<p className='text-[20px]'>
					Accede a beneficios exclusivos para zubaleros
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Asesoría fiscal personalizada
				</h2>
				<p className='text-[20px]'>
					Como parte de zubale, podrás acceder a asesoría fiscal personalizada
				</p>
			</div>,
		],
	},
	mercado_libre_afiliados: {
		utm_source: LandingUTMSource.MERCADO_LIBRE_AFILIADOS,
		title: (
			<h1>
				Haz las paces con <br />
				<b className='text-h-primary'>tus impuestos.</b>
				<br />
				¡Comienza ahora!
			</h1>
		),
		parterLogo: mercadoLibreHeruLogo,
		partnerBackground: mercadoLibreBg,
		slider: [
			<div className='flex flex-col gap-4 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Estrategia fiscal a tu medida
				</h2>
				<p className='text-[20px]'>
					Te ayudaremos a decidir cuál es tu mejor opción en términos de
					estrategia fiscal para que recibas tus ingresos por comisión como
					Afiliado.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Finaliza tu alta como afiliado
				</h2>
				<p className='text-[20px]'>
					En heru te guiamos paso a paso para completar tu registro como
					Afiliado mercado libre
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Asesoría fiscal personalizada
				</h2>
				<p className='text-[20px]'>
					Sacamos tu cita en el SAT, te damos de alta en el régimen más
					conveniente y te ayudamos con tu e.firma y sellos digitales.
				</p>
			</div>,
		],
	},
	didi: {
		utm_source: LandingUTMSource.DIDI,
		title: (
			<h1>
				Haz las paces con <br />
				<b className='text-h-primary'>tus impuestos.</b>
				<br />
				¡Comienza ahora!
			</h1>
		),
		parterLogo: didiLogo,
		partnerBackground: didiBg,
		slider: [
			<div className='flex flex-col gap-4 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Soluciones fiscales sin complicaciones
				</h2>
				<p className='text-[20px]'>
					Con heru, lleva tu situación fiscal al día sin estrés y con beneficios
					especiales solo por ser repartidor de Didi
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Beneficios pensados para ti
				</h2>
				<p className='text-[20px]'>
					Accede a todos los servicios de heru: declaración anual, facturación,
					asesoría y más… con descuentos exclusivos.
				</p>
			</div>,
			<div className='flex flex-col gap-2 text-white'>
				<h2 className='text-[40px] !font-medium leading-tight'>
					Seguridad, respaldo y ahorro
				</h2>
				<p className='text-[20px]'>
					heru te ayuda a estar al día con el SAT, evitar multas y ahorrar
					dinero. Solo por ser repartidor Didi.
				</p>
			</div>,
		],
	},
};
